import React, { useState } from 'react';
import { useFormikWizard } from 'formik-wizard';
import { useFormikContext } from 'formik';
import Error from '../Error/error';
import './OtpPage.css';
import { resendOtp } from '../../common/constants/api';

const otpPage = (wizard, formValue, previousStep, user) => {
  const [error, setError] = useState('');
  const [phoneOtp, setPhoneOtp] = useState('');
  const [emailOtp, setemailOtp] = useState('');
  const {
    errors,
    touched,
    values,
    handleBlur,
    handleChange,
    setFieldValue
  } = useFormikContext();
  const { status } = useFormikWizard();
  //allowing users to write type only numbers
  const otpResend = async type => {
    let data = {
      email: wizard?.values?.signup?.email,
      phone: wizard?.values?.signup?.mobile
    };
    type === 'MOBILE'
      ? setPhoneOtp('OTP has been sent to mobile')
      : setemailOtp('OTP has been sent to email');
    try {
      resendOtp(data, type)
        .then(res => {})
        .catch(err => {
          // throw new Error(err.response.data);
          setError(err.response.data);
          //return err.response.data;
        });
    } catch (err) {
      setError(err.response.data);
      //throw new Error(err.response.data);
    }

    let setOtpText = setTimeout(() => {
      setPhoneOtp('');
      setemailOtp('');
    }, 30000);
  };
  function validate(evt) {
    var theEvent = evt || window.event;

    // Handle paste
    if (theEvent.type === 'paste') {
      key = event.clipboardData.getData('text/plain');
    } else {
      // Handle key press
      var key = theEvent.keyCode || theEvent.which;
      key = String.fromCharCode(key);
    }
    var regex = /[0-9]|\./;
    if (!regex.test(key)) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
    }
  }
  return (
    <div>
      <div
        className={
          (wizard?.values?.signup == undefined ? 'mt-32' : 'mt-5') +
          ' py-2  max-w-sm mx-auto text-auto'
        }
      >
        {wizard?.user === 'rm' ? null : (
          <React.Fragment>
            <div className="mx-auto">
              <h3 className="text-sm text-center  mx-auto">
                Enter OTP sent to &nbsp; ******
                {wizard?.values?.signup !== undefined
                  ? wizard?.values?.signup?.mobile?.toString().substring(6)
                  : wizard?.values?.askMobile?.phone?.toString().substring(6)}
                <button
                  onClick={wizard?.previousStep}
                  // onClick={() => props.submitHandler(1)}
                  className="mx-auto text-xs text-orange-500 mt-5 ml-5 text-center text-green-500"
                >
                  Change Number
                </button>
              </h3>
              <div className="my-1 mt-5 p-3 mx-auto text-center">
                <div className="mx-auto mb-3" id="divOuter">
                  <div id="divInner">
                    <input
                      className="appearance-none mx-auto block "
                      id="mobileOtp"
                      type="text"
                      name="mobileOtp"
                      autoFocus
                      maxLength="4"
                      minLength="4"
                      placeholder=""
                      required
                      autoComplete="off"
                      onKeyPress={e => {
                        validate(e);
                      }}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </div>
                </div>
                <div className="relative left-auto max-w-sm">
                  <Error
                    touched={touched.mobileOtp}
                    message={errors.mobileOtp}
                  />
                </div>
              </div>

              <div
                // onClick={() => wizard(0)}
                className="mx-auto text-center underline"
              >
                <button
                  className="capitalize text-sm my-1 text-center mx-auto text-green-500"
                  onClick={() => otpResend('MOBILE')}
                >
                  {phoneOtp == '' ? 'Resend OTP' : ''}
                </button>
              </div>
              <div className="text-xs text-green-500 no-underline text-center">
                {phoneOtp == '' ? '' : phoneOtp}
              </div>
            </div>
          </React.Fragment>
        )}
        {wizard?.user === 'rm' ? (
          <>
            <div className="mx-auto mt-5">
              <h3 className="text-sm text-center  mx-auto">
                Enter OTP sent to Email ID
                <button
                  onClick={wizard.previousStep}
                  // onClick={() => props.submitHandler(1)}
                  className="mx-auto text-xs text-orange-500 mt-5 ml-5 text-center text-green-500"
                >
                  Change Email
                </button>
              </h3>
              <div className="my-1 mt-5 p-3 mx-auto text-center">
                <div className="mx-auto mb-3" id="divOuter">
                  <div id="divInner">
                    <input
                      className="appearance-none mx-auto block "
                      id="emailOtp"
                      type="text"
                      name="emailOtp"
                      maxLength="4"
                      minLength="4"
                      placeholder=""
                      required
                      autoComplete="off"
                      onKeyPress={e => {
                        validate(e);
                      }}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </div>
                </div>
                <div className="relative left-auto max-w-sm">
                  <Error touched={touched.emailOtp} message={errors.emailOtp} />
                </div>
              </div>

              <div className="mx-auto text-center underline">
                <a
                  className="capitalize text-sm my-1 text-center mx-auto text-green-500"
                  href="javascript:void(0)"
                  onClick={() => otpResend('EMAIL')}
                >
                  {emailOtp == '' ? 'Resend OTP' : ''}
                </a>
              </div>
              <div className="text-xs text-green-500 no-underline text-center">
                {emailOtp == '' ? '' : emailOtp}
              </div>
            </div>
          </>
        ) : null}

        <button
          id="submit"
          type="submit"
          disabled={
            wizard.values.signup !== undefined
              ? values.mobileOtp.length < 4
              : wizard?.user == 'bp'
              ? values.mobileOtp.length < 4
              : values?.emailOtp?.length < 4
          }
          className="submitButton  w-full"
        >
          REGISTER
        </button>
        <div className="text-red-200 mt-4">{status?.message}</div>
        <div className="text-red-200 mt-4">{error?.message}</div>
      </div>
    </div>
  );
};
export default otpPage;
